module.exports = __webpack_public_path__ + "img/hum.e98c0b67.gif";